import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import { FaCheck } from "react-icons/fa";
import Breadcrumb from "../components/Breadcrumb";
import MobileFooter from "../components/MobileFooter";
import axios from "axios";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import Loader from "../components/Loader";
import { toast } from "react-toastify";

const items = [
  { id: 1, title: "Captions or Subtitle", count: 28, icon: "📜" },
  { id: 2, title: "Text Generation", count: 35, icon: "✍️" },
  { id: 1, title: "Captions or Subtitle", count: 28, icon: "📜" },
  { id: 2, title: "Text Generation", count: 35, icon: "✍️" },
  { id: 1, title: "Captions or Subtitle", count: 28, icon: "📜" },
  { id: 2, title: "Text Generation", count: 35, icon: "✍️" },
  { id: 1, title: "Captions or Subtitle", count: 28, icon: "📜" },
  { id: 2, title: "Text Generation", count: 35, icon: "✍️" },
  
];

const Categorie = (props) => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [totalTool, settotalTool] = useState(0);
  const [isLoading, setisLoading] = useState(false);
  const getData = async () => {
      try {
        setisLoading(true);
        const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/activecategory_with_subcategory`);
        setisLoading(false);
        if (res.data.status) {
          setData(res.data.data);
          settotalTool(res.data.totalToolCount)
        }

      }
      catch (err) {
          setisLoading(false)
          console.log(err)
      }
  }

  useEffect(() => {
    getData();
  }, []);

  const handleNavigate =async(subCategoryId,id,toolCount)=>{
    
    if(toolCount < 1){
      // toast.warning("No Tools Available!")
      props.setAlertBox(true)
      props.showAlert("No Tools Available", "warning")
      return false
    }
    localStorage.setItem('FSID',id)
    navigate(`/subcategory/${subCategoryId}`)
  }
  return (
    <>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      <Breadcrumb
        title="Find AI By Categories"
        breadcrumbs={[
            { label: 'Categories'},
        ]}
        paragraph={`Explore world's #1 AI Tools Platform with the largest database of ${totalTool} AIs, updated daily.`}
        />
      {/* Text & Write categories */}

      <section className="bg-background-back1 overflow-hidden">
      <div className="container max-w-[80rem] mx-auto px-4 pt-5">
      {
        data && data.map((item,index)=>{
          return <>
          <div className="px-0 md:px-4 pt-6">
        <div className="">
          <div className="flex items-center gap-2 truncate">
            <h4 className="font-sans tracking-wide lg:text-2xl text-lg font-bold capitalize text-white ">{item?.category_name}</h4>
            <span className="font-sans tracking-wide lg:text-xl text-md font-bold capitalize underline truncate"></span>
          </div>
          <div className="text-xs mt-1 opacity-50 text-gray-300">{item?.categoryToolCount} AIs </div>
        </div>
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
          {/* {item?.subcategories?.map((sub) => (
            <>
            
            <div onClick={()=>handleNavigate(sub?.subcategory_label,sub?._id,sub?.toolCount)} key={sub._id} className="px-4 flex justify-between items-center blurBox rounded-xl">
              
              <div className="py-4 flex justify-start items-center h-full w-[90%] cursor-pointer text-white hover:text-primary">
            
                <div className="">
                  <h6 className="text-sm capitalize mb-1 truncate w-60  ">{sub.sub_category_name}</h6>
                  <p className="text-xs opacity-50 text-gray-300">{sub.toolCount} AIs</p>
                </div>
              </div>
              
              <div>
                
                  <div className="cursor-pointer">
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-primary" />
                    </div>
                  </div>
                
              </div>
            </div>
           
            </>
          ))} */}

          {item?.subcategories?.map((sub) => {
  const isDisabled = sub?.toolCount === 0;

  return (
    <div
      key={sub._id}
      onClick={() => {
        if (!isDisabled) {
          handleNavigate(sub?.subcategory_label, sub?._id, sub?.toolCount);
        }
      }}
      className={`px-4 flex justify-between items-center blurBox rounded-xl ${
       'cursor-pointer hover:text-primary'
      }`}
    >
      <div className="py-4 flex justify-start items-center h-full w-[90%] text-white">
        <div>
          <h6 className="text-sm capitalize mb-1 truncate w-60">{sub.sub_category_name}</h6>
          <p className="text-xs opacity-50 text-gray-300">{sub.toolCount} AIs</p>
        </div>
      </div>

      <div>
        <div className="flex items-center gap-2">
          {!isDisabled && <FaCheck className="text-primary" />}
        </div>
      </div>
    </div>
  );
})}

        </div>
      </div>
          </>
        })
      }
      {/* <div className="px-4 pt-6">
        <div className="">
          <div className="flex items-center gap-2 truncate">
            <h4 className="font-sans tracking-wide lg:text-2xl text-lg font-bold capitalize text-white ">Text & Writing</h4>
            <span className="font-sans tracking-wide lg:text-xl text-md font-bold capitalize underline truncate"></span>
          </div>
          <div className="text-xs mt-1 opacity-50 text-gray-300">1001 AIs for 35 Tasks </div>
        </div>
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
          {items.map((item) => (
            <Link to="/text-write/captions-or-subtitle">
            <div key={item.id} className="px-4 flex justify-between items-center blurBox rounded-xl">
              
              <div className="py-4 flex justify-start items-center h-full w-[90%] cursor-pointer text-white hover:text-primary">
                <div className="w-6 h-6 flex justify-center items-center">{item.icon} </div>
                <div className="ml-4">
                  <h6 className="text-sm capitalize mb-1 truncate w-60  ">{item.title}</h6>
                  <p className="text-xs opacity-50 text-gray-300">{item.count} AIs</p>
                </div>
              </div>
              
              <div>
                
                  <div className="cursor-pointer">
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-primary" />
                    </div>
                  </div>
                
              </div>
            </div>
            </Link>
          ))}
        </div>
      </div> */}

      {/* Image categories */}
      {/* <div className="px-4 pt-6 bg-background-back1">
        <div className="">
          <div className="flex items-center gap-2 truncate">
            <h4 className="font-sans tracking-wide lg:text-2xl text-lg font-bold capitalize text-white ">Image</h4>
            <span className="font-sans tracking-wide lg:text-xl text-md font-bold capitalize underline truncate"></span>
          </div>
          <div className="text-xs mt-1 opacity-50 text-gray-300">1001 AIs for 35 Tasks</div>
        </div>
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
          {items.map((item) => (
            <Link to="/text-write/captions-or-subtitle">
            <div key={item.id} className="px-4 flex justify-between items-center blurBox rounded-xl">
              
              <div className="py-4 flex justify-start items-center h-full w-[90%] cursor-pointer text-white hover:text-primary">
                <div className="w-6 h-6 flex justify-center items-center">{item.icon} </div>
                <div className="ml-4">
                  <h6 className="text-sm capitalize mb-1 truncate w-60">{item.title}</h6>
                  <p className="text-xs opacity-50 text-gray-300">{item.count} AIs</p>
                </div>
              </div>
              
              <div>
                
                  <div className="cursor-pointer">
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-primary" />
                    </div>
                  </div>
                
              </div>
            </div>
            </Link>
          ))}
        </div>
      </div> */}

      {/* Video categories */}
      {/* <div className="px-4 pt-6 bg-background-back1">
        <div className="">
          <div className="flex items-center gap-2 truncate">
            <h4 className="font-sans tracking-wide lg:text-2xl text-lg font-bold capitalize text-white ">Video</h4>
            <span className="font-sans tracking-wide lg:text-xl text-md font-bold capitalize underline truncate"></span>
          </div>
          <div className="text-xs mt-1 opacity-50 text-gray-300">1001 AIs for 35 Tasks</div>
        </div>
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
          {items.map((item) => (
            <Link to="/text-write/captions-or-subtitle">
            <div key={item.id} className="px-4 flex justify-between items-center blurBox rounded-xl">
              
              <div className="py-4 flex justify-start items-center h-full w-[90%] cursor-pointer text-white hover:text-primary">
                <div className="w-6 h-6 flex justify-center items-center">{item.icon} </div>
                <div className="ml-4">
                  <h6 className="text-sm capitalize mb-1 truncate w-60">{item.title}</h6>
                  <p className="text-xs opacity-50 text-gray-300">{item.count} AIs</p>
                </div>
              </div>
              
              <div>
                
                  <div className="cursor-pointer">
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-primary" />
                    </div>
                  </div>
                
              </div>
            </div>
            </Link>
          ))}
        </div>
      </div> */}
      </div>
      </section>
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default Categorie;
